import { type FC, useMemo, useRef, useState } from 'react';
import { FaceliftDrawer } from '@/components/Atoms/FaceliftDrawer';
import DrawerContent, { type ISelectedItem } from './ DrawerContent';
import DrawerFooter from './DrawerFooter';

export type IItem = {
	name: string;
	key: string;
	options: { label: string; id: string | number; showCheckbox?: boolean }[];
};
interface IFiltersDrawerProps {
	title?: string;
	items?: IItem[];
	defaultValues?: ISelectedItem[];
	showSearch?: boolean;
	onChangeFilter?: (selectedItems: ISelectedItem[]) => void;
}

const FiltersDrawer: FC<IFiltersDrawerProps> = ({ title, items = [], onChangeFilter, defaultValues = [], showSearch }) => {
	const [selectedItems, setSelectedItems] = useState<ISelectedItem[]>(defaultValues);
	const [drawerItems, setDrawerItems] = useState<ISelectedItem[]>(defaultValues);

	// Create a ref for FaceliftDrawer
	const drawerRef = useRef<{ closeDrawer: () => void }>(null);

	const handleApply = () => {
		onChangeFilter?.(selectedItems);
		setDrawerItems(selectedItems);
		drawerRef.current?.closeDrawer();
	};
	const handleClear = () => {
		onChangeFilter?.([]);
		setDrawerItems([]);
		drawerRef.current?.closeDrawer();
	};

	useMemo(() => {
		setSelectedItems(defaultValues);
	}, [defaultValues]);

	return (
		<FaceliftDrawer
			ref={drawerRef}
			title={title}
			defaultValues={drawerItems}
			onClear={handleClear}
			bodyContent={
				<DrawerContent
					items={items}
					showSearch={showSearch}
					defaultValues={selectedItems}
					onChange={setSelectedItems}
				/>
			}
			footer={<DrawerFooter onClear={handleClear} onApply={handleApply} />}
			sx={{
				borderTopLeftRadius: '12px',
				borderBottomLeftRadius: '12px',
			}}
		/>
	);
};

export default FiltersDrawer;
